/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolComputerIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-computer"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.63 22.1Q1.07 22.1 0.69 21.71Q0.3 21.32 0.3 20.77Q0.3 20.23 0.69 19.84Q1.07 19.45 1.63 19.45L22.38 19.45Q22.93 19.45 23.31 19.84Q23.7 20.23 23.7 20.77Q23.7 21.32 23.31 21.71Q22.93 22.1 22.38 22.1ZM3.85 18.45Q2.75 18.45 1.98 17.68Q1.2 16.9 1.2 15.8L1.2 4.6Q1.2 3.5 1.98 2.73Q2.75 1.95 3.85 1.95L20.15 1.95Q21.25 1.95 22.02 2.73Q22.8 3.5 22.8 4.6L22.8 15.8Q22.8 16.9 22.02 17.68Q21.25 18.45 20.15 18.45Z" fill={color} />
    </svg>
  );
}
